// client/src/components/OutputDisplay.jsx
import React, { useState } from 'react';
import '../App.css';
const OutputDisplay = ({ results }) => {
    const [activeTab, setActiveTab] = useState('Topics');
    const [copiedText, setCopiedText] = useState('');

    const copyToClipboard = (text, type) => {
        navigator.clipboard.writeText(text);
        setCopiedText(type);
        setTimeout(() => setCopiedText(''), 2000);
    };

    const renderContent = () => {
        if (activeTab === 'Topics') {
            return (
                <ul className="space-y-3">
                    {results.topics?.map((topic, index) => (
                        <li key={index} className="flex justify-between items-center p-3 bg-white border-l-4 border-indigo-500 shadow-sm rounded-lg">
                            <span className="font-medium text-gray-700">{index + 1}. {topic}</span>
                            <button 
                                onClick={() => copyToClipboard(topic, `Topic ${index + 1}`)}
                                className="text-xs text-indigo-600 hover:text-indigo-800 ml-4 font-semibold"
                            >
                                {copiedText === `Topic ${index + 1}` ? 'Copied!' : 'Copy'}
                            </button>
                        </li>
                    ))}
                </ul>
            );
        } else if (activeTab === 'Outlines') {
            return (
                <div className="space-y-6">
                    {results.outlines?.map((outline, index) => (
                        <div key={index} className="p-5 bg-white shadow-lg rounded-lg border border-gray-200">
                            <div className="flex justify-between items-center mb-3">
                                <h3 className="text-xl font-bold text-indigo-700">Outline for: {outline.title}</h3>
                                <button 
                                    onClick={() => copyToClipboard(outline.sections.join('\n'), `Outline ${index + 1}`)}
                                    className="text-sm text-indigo-600 hover:text-indigo-800 font-semibold"
                                >
                                    {copiedText === `Outline ${index + 1}` ? 'Copied!' : 'Copy Outline'}
                                </button>
                            </div>
                            <ul className="space-y-2 ml-4">
                                {outline.sections?.map((section, sIndex) => (
                                    <li key={sIndex} className="text-gray-600 list-disc">{section}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            );
        } else if (activeTab === 'Headlines') {
            return (
                <ul className="space-y-3">
                    {results.headlines?.map((headline, index) => (
                        <li key={index} className="flex justify-between items-center p-3 bg-white border-l-4 border-green-500 shadow-sm rounded-lg">
                            <span className="font-medium text-gray-700">{headline}</span>
                            <button 
                                onClick={() => copyToClipboard(headline, `Headline ${index + 1}`)}
                                className="text-xs text-green-600 hover:text-green-800 ml-4 font-semibold"
                            >
                                {copiedText === `Headline ${index + 1}` ? 'Copied!' : 'Copy'}
                            </button>
                        </li>
                    ))}
                </ul>
            );
        }
    };

    return (
        <div className="mt-10">
            <div className="flex border-b-2 border-indigo-200 mb-6 justify-center gap-2">
                {['Topics', 'Outlines', 'Headlines'].map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`py-3 px-8 text-lg font-bold rounded-t-xl transition duration-200 focus:outline-none shadow-sm ${
                            activeTab === tab 
                                ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white border-b-4 border-indigo-600 scale-105' 
                                : 'bg-indigo-50 text-indigo-600 hover:bg-indigo-100 hover:text-indigo-800'
                        }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>
            <div className="p-6 bg-white rounded-xl shadow-2xl min-h-[320px] border border-indigo-100">
                {renderContent()}
            </div>
        </div>
    );
};

export default OutputDisplay;